import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { APP_LABELS } from '@config/app-config';
import CustomModal from '@utilities/CustomModal';

import EnrollmentAndOccupancy from './enrollment-and-occupancy';
import Participants from './participants';

const CampParticipationsAndEnrollmentTab = props => {
  const { setLoader, status } = props;

  const [activeTab, setActiveTab] = useState('Enrollment And Occupancy');
  const [showPopup, setShowPopup] = useState(false);
  const [currentTab, setCurrentTab] = useState('');
  const [lastActiveTab, setLastActiveTab] = useState('');

  const onActive = value => {
    if (value !== activeTab && sessionStorage.getItem('dirty') === 'true') {
      setShowPopup(true);
    } else {
      setActiveTab(value);
    }
    setCurrentTab(value);
    setLastActiveTab(activeTab);
  };

  const handleOk = () => {
    setActiveTab(currentTab);
    setShowPopup(false);
  };

  const handleCancel = () => {
    const activetab = lastActiveTab;
    document.getElementById(activetab).click();
    setActiveTab(activetab);
    setShowPopup(false);
  };

  return (
    <>
      <div className="ymca-completeBox">
        <div className="ymca-directorInfo ymca-globalMetrics">
          <ul className="nav nav-tabs ymca-navTabs" id="myTab">
            <li className="nav-item ymca-navItems">
              <button
                className="nav-link ymca-navLinks active"
                id="Enrollment And Occupancy"
                data-bs-toggle="tab"
                data-bs-target="#enrollmentAndOccupancy"
                type="button"
                role="tab"
                aria-controls="enrollmentAndOccupancy"
                aria-selected="true"
                onClick={() => {
                  onActive('Enrollment And Occupancy');
                }}
              >
                Enrollment and Occupancy
              </button>
            </li>
            <li className="nav-item ymca-navItems">
              <button
                className="nav-link ymca-navLinks"
                id="Participants"
                data-bs-toggle="tab"
                data-bs-target="#participants"
                type="button"
                role="tab"
                aria-controls="participants"
                aria-selected="false"
                onClick={() => {
                  onActive('Participants');
                }}
              >
                Participants
              </button>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane ymca-tabPaneInner fade show active"
              id="enrollmentAndOccupancy"
              role="tabpanel"
              aria-labelledby="Enrollment And Occupancy"
            >
              {activeTab === 'Enrollment And Occupancy' && (
                <EnrollmentAndOccupancy setLoader={setLoader} status={status} />
              )}
            </div>
            <div
              className="tab-pane ymca-tabPaneInner fade"
              id="participants"
              role="tabpanel"
              aria-labelledby="Participants"
            >
              {activeTab === 'Participants' && (
                <Participants setLoader={setLoader} status={status} />
              )}
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        show={showPopup}
        type={APP_LABELS.WARNING}
        message="You have some unsaved changes. If you leave before saving, your
                changes will be lost."
        submitButtonName="Ok"
        onSubmit={handleOk}
        cancelButtonName="Cancel"
        onCancel={handleCancel}
      />
    </>
  );
};

CampParticipationsAndEnrollmentTab.propTypes = {
  setLoader: PropTypes.func.isRequired,
  status: PropTypes.objectOf(PropTypes.any).isRequired
};

export default CampParticipationsAndEnrollmentTab;
